// import React, { useState } from 'react';
// import * as jnb from "react-bootstrap";
// import { BiArrowFromLeft } from "react-icons/bi";
// import { useNavigate } from 'react-router-dom';
// import PublicHeader from '../Header/PublicHeader';
// import * as HERBUI from "react-bootstrap";
// import { CommonPageHeading } from '../CommonUtils/CommonHeading/CommonPageHeading';

// export default function DashBoardMain() {
//     const history = useNavigate();

//     const tabNames = [
//         {
//             "serviceName": 'Worker Registration Form',
//             "target": "/WorkerRegistrationForm"
//         },
//     ]
//     const [searchText, setSearchText] = useState('');
//     const [filteredTabs, setFilteredTabs] = useState(tabNames);

//     const handleSearch = (event) => {
//         const text = event.target.value;
//         setSearchText(text);
//         const filteredTabs = tabNames.filter((tab) =>
//             tab.serviceName.toLowerCase().includes(text.toLowerCase())
//         );
//         setFilteredTabs(filteredTabs);
//     };

//     function navTarget(target) {
//         history(target);
//     }

//     function navTargett() {
//         history("/EstablishmentApplication");
//     }

//     return (
//         <>
//             <PublicHeader />
//             <div className="main_section">
//             </div>
//             <CommonPageHeading heading="Services" />
//             <HERBUI.Container className='mt-4 pt-2 px-4'>
//                 <HERBUI.Row className='mt-3'>
//                     <div className="b-flex text-end ">
//                         <input
//                             type="text"
//                             placeholder="Search..."
//                             value={searchText}
//                             onChange={handleSearch} />
//                     </div>
//                     {filteredTabs && filteredTabs.map((c, i) => {
//                         return (
//                             <HERBUI.Row>
//   <HERBUI.Col xs={12} sm={6} md={3} lg={3} xl={3} key={`${i}-1`}>
//     <div className="cards card1 bg-white mb-4">
//       <div className="cards-body" onClick={() => { navTarget(c?.target) }}>
//         <div className="go-corner">
//           <div className="go-arrow">
//             <BiArrowFromLeft className="cardico icon-size-header2" />
//           </div>
//         </div>
//         <h5 className="cards_title float-start">{c?.serviceName}</h5>
//       </div>
//     </div>
//   </HERBUI.Col>

// </HERBUI.Row>
                      
//                         );
//                     })}
//                 </HERBUI.Row>
//             </HERBUI.Container>

//         </>
//     )
// }

import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"
import * as HERBUI from "react-bootstrap";
import { BiArrowFromLeft } from 'react-icons/bi';
import Header from '../Header/Header';
import { CommonAxiosGet } from '../CommonUtils/CommonAxios/CommonAxios';
import { config } from '../CommonUtils/CommonUrl/CommonUrls';
import { Field, FormikProvider, useFormik } from 'formik';
import { BsChevronDown } from 'react-icons/bs';
import { FaSearch } from 'react-icons/fa';
import { useSelector } from 'react-redux';

export default function Dashboard() {
    let navigate = useNavigate();

    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails);

    // let navigate = useNavigate();
    // const [intervalId, setIntervalId] = useState(null);
    // const time = localStorage.getItem("expiresTime");
    // // Define a function to check for cookie expiration
    // const checkCookieExpiration = () => {
    //   const jwtToken = Cookies.get('jwtToken');
    //   if (!jwtToken) {
    //     clearInterval(intervalId); // Clear the interval
    //     Swal.fire({
    //       text: "Your session has expired. Do you want to continue?",
    //       icon: "warning",
    //       backdrop: false,
    //       showCancelButton: true,
    //       confirmButtonColor: "#3085d6",
    //       cancelButtonColor: "#d33",
    //       confirmButtonText: "Yes",
    //       cancelButtonText: "No"
    //     }).then((val) => {
    //       if (val.isConfirmed) {
    //         const continueToken = Cookies.get('continueToken');
    //         Cookies.set("jwtToken", continueToken, { expires: new Date(time) });
    //         // Restart the interval to check for expiration
    //         const newIntervalId = setInterval(checkCookieExpiration, 1000);
    //         setIntervalId(newIntervalId); // Update the intervalId state
    //       } else {
    //         clearInterval(intervalId);
    //         navigate('/login');
    //       }
    //     });
    //   }
    // };


   // const [showList, setList] = useState([])
    // function GetChequeInReport() {
    //     let url = config.url.BOC_URL + "getPositions";
    //     CommonAxiosGet(url).then((response) => {
    //         if (response?.data?.status === true) {

    //             let len = response?.data?.positions?.length
    //             if (len === 1) {
    //                 let value = response?.data?.positions[0]?.role_id
    //                 setOrgId(response?.data?.positions[0]?.org_id)
    //                 setRoleId(value)
    //                 GetServicesReport(value, 'single')
    //             }
    //             setList(response?.data?.positions);
    //         }
    //     })
    // }
    const [showSeriveList, setServiceList] = useState([])
    const [showOrgId, setOrgId] = useState()
    const [showRoleId, setRoleId] = useState()
    let Role;
    if(loginreducer?.loginData?.role === "BUILDER") {
        Role = "b"
    } else if(loginreducer?.loginData?.role === "WORKER") {
        Role = "w"
    } else if(loginreducer?.loginData?.role === "ALO") {
        Role ="a"
    }
    function RoleBasedServices() {
        let url = config.url.BOC_URL + "getservices-"+Role;
        // +"?role_id=" + loginreducer?.loginData?.user_role;
        CommonAxiosGet(url).then((response) => {
            if (response?.data?.status === true) {
                setServiceList(response.data.services);
            }
            else {
                setServiceList([])
            }
        })
    }
    // function GetServicesReport(e, status) {
    //     let role;
    //     if (status === "multiple") {
    //         let value = e.target.value
    //         role = value.split('-')[0]
    //         setOrgId(value.split('-')[1])
    //         setRoleId(role)
    //         RoleBasedServices(role)
    //         // if (role !== null) {
    //         //     RoleBasedServices(role)
    //         // }
    //         // else if(role == null){
    //         //     Sweetalert("No Services Found", "warning")
    //         // }
    //         // else  if(role === "0"){
    //         //     Sweetalert("Select Services", "warning")
    //         // }
    //     }
    //     else if (status === "single") {
    //         role = e
    //         RoleBasedServices(role)
    //     }
    // }

    useEffect(() => { RoleBasedServices() }, [])
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Position: ""
        }
    })
    const [search, setSearch] = useState("");
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"></div>
            <HERBUI.Container className='mt-4 pt-2 px-4'>
                <FormikProvider value={Formik}>
                    <HERBUI.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                        <HERBUI.Row>
                            <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
                                <div className="inner-herbpage-service-title1">
                                    <h1>Services</h1>
                                </div>
                                {/* {showList?.length > 1 && (<div className='text-left'>
                                    <label> Select Login : &emsp;</label>
                                    <label>
                                        <HERBUI.InputGroup className="">
                                            <Field as="select" name="Position" className="form-control w-100 mt-1"
                                                onChange={(e) => {
                                                    GetServicesReport(e, 'multiple')
                                                }} >
                                                <option value="0">--Select--</option>
                                                {showList !== undefined && showList?.map((cs, i) => {
                                                    return (
                                                        <option key={i} value={`${cs.role_id}-${cs.org_id}`} >{cs.positions_name}</option>
                                                    );
                                                })}
                                            </Field>
                                            <BsChevronDown className='icon-inside-inputfiled' style={{ top: '15' }}></BsChevronDown>
                                        </HERBUI.InputGroup>
                                    </label>
                                </div>)} */}
                                <div className='text-left'>
                                    <label>
                                        <HERBUI.InputGroup className="">
                                        <input className="form-control" id="search" name={`search_${Date.now()}`} type="text" placeholder="search" onChange={event => setSearch(event.target.value)} />
                                            <FaSearch className='icon-inside-inputfiled' style={{ top: '15' }}></FaSearch>
                                        </HERBUI.InputGroup>
                                    </label>
                                </div>
                            </HERBUI.Col>

                        </HERBUI.Row>
                        <HERBUI.Row>
                        </HERBUI.Row>
                        <HERBUI.Row className='mt-3'>
                           {/* {showSeriveList?.map((cs, i) => { */}
                        {showSeriveList && showSeriveList.filter(element => element.service_name?.toLowerCase().includes(search?.toLowerCase())).map((cs, i) => {
                                return (
                                    <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3} key={i}>
                                        <div className="cards card1 bg-white mb-4">
                                            <div className="cards-body"
                                                onClick={() => { navigate(cs?.target, { state: { org_id: showOrgId ,role:showRoleId} }); }}>
                                                <div className="go-corner"><div className="go-arrow">
                                                    <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                                <h5 className="cards_title float-start">{cs?.service_name}</h5>
                                            </div>
                                        </div>
                                    </HERBUI.Col>
                                )
                            })}
                        </HERBUI.Row>
                        {/* <HERBUI.Row className='mt-3'> */}

                        {/* <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                <div className="cards card1 bg-white ">
                                    <div className="cards-body"
                                        onClick={() => { navigate("/CESSPaymentScreen"); }}>

                                        <div className="go-corner"  > <div className="go-arrow">
                                            <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                        <h5 className="cards_title float-start"> CESS Payment Screen</h5>
                                    </div>
                                </div>
                            </HERBUI.Col> */}
                        {/* {loginreducer?.loginData?.user_role === 1 ? <React.Fragment>
                                <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body"
                                            onClick={() => { navigate("/InWardChequeIn"); }}>
                                            <div className="go-corner"><div className="go-arrow">
                                                <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                            <h5 className="cards_title float-start"> InWard Maker ChequeIn</h5>
                                        </div>
                                    </div>
                                </HERBUI.Col>
                            </React.Fragment> : loginreducer?.loginData?.user_role === 2 ? <React.Fragment>
                                <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body"
                                            onClick={() => { navigate("/InwardCheckerReport"); }}>

                                            <div className="go-corner"  > <div className="go-arrow">
                                                <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                            <h5 className="cards_title float-start"> Inward Checker Report</h5>
                                        </div>
                                    </div>
                                </HERBUI.Col>
                            </React.Fragment> : loginreducer?.loginData?.user_role === 3 ? <React.Fragment>
                                <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body"
                                            onClick={() => { navigate("/ApprovalReport"); }}>

                                            <div className="go-corner"  > <div className="go-arrow">
                                                <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                            <h5 className="cards_title float-start"> Approval Report</h5>
                                        </div>
                                    </div>
                                </HERBUI.Col>
                                <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body"
                                            onClick={() => { navigate("/ApprovalPaymentReport"); }}>

                                            <div className="go-corner"  > <div className="go-arrow">
                                                <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                            <h5 className="cards_title float-start">Approval Payment Report</h5>
                                        </div>
                                    </div>
                                </HERBUI.Col>
                                <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body"
                                            onClick={() => { navigate("/InwardDashboard"); }}>

                                            <div className="go-corner"  > <div className="go-arrow">
                                                <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                            <h5 className="cards_title float-start">Inward Dashboard</h5>
                                        </div>
                                    </div>
                                </HERBUI.Col>
                            </React.Fragment> : loginreducer?.loginData?.user_role === 4 ? <React.Fragment>
                                <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                    <div className="cards card1 bg-white mb-4">
                                        <div className="cards-body"
                                            onClick={() => { navigate("/AloReportDashboard"); }}>
                                            <div className="go-corner"><div className="go-arrow">
                                                <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                            <h5 className="cards_title float-start">Alo Report Dashboard</h5>
                                        </div>
                                    </div>
                                </HERBUI.Col>
                            </React.Fragment> : */}
                        {/* <React.Fragment>
                            <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                <div className="cards card1 bg-white mb-4">
                                    <div className="cards-body"
                                        onClick={() => { navigate("/WorkerRegistrationReport"); }}>
                                        <div className="go-corner"><div className="go-arrow">
                                            <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                        <h5 className="cards_title float-start">Worker Registration Report</h5>
                                    </div>
                                </div>
                            </HERBUI.Col>
                            <HERBUI.Col xs={12} sm={12} md={3} lg={3} xl={3}>
                                <div className="cards card1 bg-white mb-4">
                                    <div className="cards-body"
                                        onClick={() => { navigate("/ZclWorkerRegReport"); }}>
                                        <div className="go-corner"><div className="go-arrow">
                                            <BiArrowFromLeft className="cardico icon-size-header2" /> </div> </div>
                                        <h5 className="cards_title float-start">Zcl Worker Registration Report</h5>
                                    </div>
                                </div>
                            </HERBUI.Col>
                        </React.Fragment> */}
                        {/* } */}

                        {/* </HERBUI.Row> */}
                    </HERBUI.Form>
                </FormikProvider>
            </HERBUI.Container>
        </React.Fragment>

    )
}



